import vaultHistoryComponents from "../../../../../web-sh/src/pages/admin/vault/components/history";

import Filter from "./Filter";

vaultHistoryComponents.Filter = Filter;

export default vaultHistoryComponents